import { render, staticRenderFns } from "./FormRegisterConfirm.vue?vue&type=template&id=4b30da7e&"
import script from "./FormRegisterConfirm.vue?vue&type=script&lang=js&"
export * from "./FormRegisterConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b30da7e')) {
      api.createRecord('4b30da7e', component.options)
    } else {
      api.reload('4b30da7e', component.options)
    }
    module.hot.accept("./FormRegisterConfirm.vue?vue&type=template&id=4b30da7e&", function () {
      api.rerender('4b30da7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormRegisterConfirm.vue"
export default component.exports